import React, {
  useContext,
  useEffect,
  useState
} from 'react';

import PropTypes from 'prop-types';

import {
  Heading,
  Text,
  H5Bold,
  B1Regular
} from 'src/StyledComponents';

import Rest from 'src/Services/Rest';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  tagOnCampaignPageLoad,
  tagOnCampaignSubmitSuccess,
  tagOnCampaignSubmitError,
  tagOnFibreIsAvailablePageLoad,
  tagOnFibreIsNotAvailablePageLoad
} from 'src/Tagging/SalesCampaignTagging';

import {
  sha256
} from 'src/Utility/sha256';

import {
  createArray,
  checkInputValidity,
  getEnv,
  getTrackingIds,
  isMobileView
} from 'src/Utility/utility';

import {
  GreenTick,
  WrongCircle,
  GreenCommunicationsIcon
} from 'src/Components/Common/Svg';

import WhyChooseVodacomFibre from 'src/Components/Common/WhyChooseVodacomFibre/WhyChooseVodacomFibre';

import HomeBanner from 'src/Common/Images/home-page-hero-banner.png';

import HomeBannerMobile from 'src/Common/Images/home-page-hero-banner-mobile.png';

import LeadsForm from './LeadsForm/LeadsForm';

import DealsSuccess from './DealsSuccess/DealsSuccess';

import ErrorBanner from './ErrorBanner/ErrorBanner';

import FibreDealsSearch from './FibreDealsSearch/FibreDealsSearch';

import './DealsForFTTHS.css';

const coverageState = {
  DEFAULT: 'DEFAULT',
  HAS_COVERAGE: 'HAS_COVERAGE',
  NO_COVERAGE: 'NO_COVERAGE'
};

const DealsForFTTHS = () => {

  const [ currentScreen, setCurrentScreen ] = useState('form');
  const [ showError, setShowError ] = useState(false);
  const [ isError, setIsError ] = useState(false);
  const context = useContext(SalesContext);
  const [ hasCoverage, sethasCoverage ] = useState(coverageState.DEFAULT);
  const [ geocodeAddress, setGeocodeAddress ] = useState(null);
  const [ referenceNo, setReferenceNo ] = useState('');

  const [ formData, setFormData ] = useState({
    formComponents: {
      searchBar: {
        name: 'Start by checking if fibre is available in your area',
        type: 'searchBar',
        value: '',
        width: 100,
        validations: {
          required: true,
          invalidMessage: ''
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Type your address here',
          tabIndex: '2'
        },
        isValid: true,
        isTouched: false
      }
    }
  });

  const coverageSearch = new URLSearchParams(window.location.search).get('coverageSearch') || 'off';

  const formCompArray = createArray(formData.formComponents);

  const setAddress = (address) => {

    Rest.getGeocodeFromAddress(address)
      .then(res => {

        const addressPayload = {};

        for (const addressComponent of res?.data?.result?.results[0]?.address_components) {

          addressPayload[addressComponent.administrative_type] = addressComponent.long_name;
        }

        setGeocodeAddress({
          unitNumber: addressPayload.unit || '',
          buildingName: addressPayload.building || '',
          streetNumber: addressPayload.street_number || '',
          streetAddress: addressPayload.route || '',
          suburb: addressPayload.suburb || '',
          city: addressPayload.town || '',
          province: addressPayload.province || '',
          latitude: `${ res?.data?.result?.results[0]?.geometry?.location?.lat || '' }`,
          longitude: `${ res?.data?.result?.results[0]?.geometry?.location?.lng || '' }`,
          docid: res?.data?.result?.results[0]?.docid || '',
          postalCode: (addressPayload.post_street || addressPayload.post_box) || ''
        });

        Rest.getEligibilityOffers(res?.data?.result?.results[0]?.geometry?.location?.lat, res?.data?.result?.results[0]?.geometry?.location?.lng)
          .then(eligibilityRes => {

            if (eligibilityRes?.status === 200) {

              sethasCoverage(coverageState.HAS_COVERAGE);
              tagOnFibreIsAvailablePageLoad();
            } else {

              sethasCoverage(coverageState.NO_COVERAGE);
              tagOnFibreIsNotAvailablePageLoad();
            }
          })
          .catch(_error => {

            sethasCoverage(coverageState.NO_COVERAGE);
            tagOnFibreIsNotAvailablePageLoad();
          })
          .catch(error => {

            if (error?.response?.status === 404) {

              sethasCoverage(coverageState.NO_COVERAGE);
              tagOnFibreIsNotAvailablePageLoad();
            } else {

              sethasCoverage(coverageState.NO_COVERAGE);
              tagOnFibreIsNotAvailablePageLoad();
            }
          });
      });
  };

  const getAddressDetails = (address) => {

    formComponentChangeHandler(address, 'searchBar');
    setAddress(address);
  };

  const resetCoverageState = () => {

    sethasCoverage(coverageState.DEFAULT);
  };

  const formComponentChangeHandler = (value, inputIdentifier) => {

    if (!formData.formComponents.isTouched) {

      formData.formComponents.isTouched = true;
    }

    const formCompsCopy = { ...formData.formComponents };
    const changedComponent = {
      ...formCompsCopy[inputIdentifier],
      value: value
    };

    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    changedComponent.isTouched = true;

    const newFormComps = {
      ...formCompsCopy,
      [inputIdentifier]: changedComponent
    };

    const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid
    });
  };

  const FibreStatusSection = (props) => {

    return (
      <div className="mmr2-fibre-availble-section-wrapper">

        <div className="mmr2-available-msg-wrapper">
          <div className="header-wrapper">

            <div className="mmr2-tick-icon-wrapper">
              {props.status === 'success'

                ? <GreenTick />

                : <WrongCircle />
              }
            </div>

            <H5Bold
              automationidattr={props.heading}
              margin_size={'0 0 0.5em 0.30em'}
              marginm={'0 0 0.5em 0'}
              textalignm="center">

              {props.heading}
            </H5Bold>
          </div>

          <div className="description-align">

            <B1Regular
              automationidattr={'GreatNewsDesc'}
              paddingsize={'0 0 1em 0.6em'}
              paddingm={'0 0 2em 0'}
              textalign={'center'}>

              {props.desc}
            </B1Regular>
          </div>
        </div>
      </div>
    );
  };

  const Banner = () => {

    return (

      <div className="redirect-image">

        <a href='https://www.vodacom.co.za/cloud/shopping/homeinternet?icmp=CampaignCallMeBackFibreRedirect'
          target="_blank"
          style={{ display: 'flex', justifyContent: 'center' }}

          rel="noopener noreferrer">
          <img className="imageBanner"
            src={`https://content${ getEnv() }.vodacom.co.za/content/fibre/provider/images/saleslead_banner.png`}
            alt='Vodacom No Fibre Banner' />
        </a>
      </div>
    );
  };
  
  const NewBanner = () => {

    return (

      <div className="redirect-image">

        <a href={`https://www${ getEnv() }.vodacom.co.za/vodacom/fibre/sales/leads`}
          target="_blank"
          style={{ display: 'flex', justifyContent: 'center' }}

          rel="noopener noreferrer">
          <img className="imageBanner"
            src={isMobileView() ? HomeBannerMobile : HomeBanner}
            alt='Vodacom Fibre Banner' />
        </a>
      </div>
    );
  };

  const submitClickHandler = (data) => {

    setIsError(false);
    context.setShowSpinner(true);
    data.campaignName = new URLSearchParams(window.location.search).get('campaignName') || '';

    Rest.submitLeadCampaign({
      firstName: data?.contactFirstName,
      lastName: data?.contactLastName,
      mobileNumber: data?.contactMobilePhoneNumber,
      email: data?.contactEmailAddress,
      campaignName: data?.campaignName,
      preferredTime: data?.preferredTime,
      mrktIndicator: getTrackingIds(),
      additionalComments: data?.additionalNotes,
      installationAddress: geocodeAddress === null ? {} : geocodeAddress
    })
      .then(res => {

        context.setShowSpinner(false);
        setCurrentScreen('success');
        let hashedCode = '';
        setReferenceNo(res?.data?.result?.referenceNumber);

        try {

          hashedCode = sha256(data.contactMobilePhoneNumber);
        } catch (error) {

          console.error('Error in hashing: ', error);
        }
        tagOnCampaignSubmitSuccess(hashedCode, res?.data?.result?.referenceNumber);
      })
      .catch(_error => {

        context.setShowSpinner(false);
        setIsError(true);
        setShowError(true);
        setTimeout(() => setShowError(false), 5000);
        tagOnCampaignSubmitError(
          'Something went wrong. Please try again later.'
        );
      });
  };

  useEffect(() => {

    tagOnCampaignPageLoad();
  }, []);

  return (

    <div className="deals-for-ftths-container">

      {showError &&

        <ErrorBanner
          closeBanner={() => setShowError(false)}
          message="Due to a technical glitch, we're not able to find your address. Please refresh the page or try again later." />
      }

      {/* <button
        className="deals-for-ftths-btn-back"
        onClick={props.history.goBack}>

        <span>&#9668;</span>
        <span style={{ marginLeft: '5px' }}>Back</span>
      </button> */}

      <div className={coverageSearch === 'off' && currentScreen === 'form' ? 'deals-for-ftths-new-main-body' : 'deals-for-ftths-main-body'}>

        {coverageSearch === 'off'

          ? currentScreen !== 'form'

            ? <>
              <div className='deals-for-ftths-heading-container'>

                <Heading>Thank you!</Heading>

                <Text fontSize="18" color="#333">
                  You are one step closer to a better internet solution! Please give us your information and a call centre agent will be in touch.
                </Text>
                <br />
              </div>
            </>

            : null

          : <>

            <Heading>Call me</Heading>

            <Text fontSize="18" color="#333">
              You are one step closer to a better internet solution!
            </Text>
            <br />
          </>
        }

        {coverageSearch === 'off'

          ? <>

            {currentScreen === 'form'

              ? <div className='deals-for-ftths-new-container'>

                <div className='deals-for-ftths-main-form-container'>

                  <div className='deals-for-ftths-options-container'>
                    <GreenCommunicationsIcon />
                    <div className='deals-for-ftths-options-header'>Need Fibre?</div>
                    <div className='deals-for-ftths-options-header'>We’ll call you back</div>
                    <div className='deals-for-ftths-options-description'>Give us your details and we’ll call to help you choose the perfect plan and get you connected hassle-free.</div>
                  </div>

                  <div className='deals-for-ftths-main-container'>
                    <LeadsForm
                      onSubmit={submitClickHandler}
                      apiError={isError}
                      isNewForm={true} />
                  </div>
                </div>

                <div className='divider-container'>
                  <div className='divider-upper-sub-container'>
                    <div className='divider-upper'></div>
                  </div>
                  <div className='divider-lower-sub-container'>
                    <div className='divider-lower'></div>
                  </div>
                </div>

                <div style={{background: 'white'}}>
                  <NewBanner />
                </div>
              </div>

              : <>
                <DealsSuccess
                  referenceNo={referenceNo} />
              </>
            }
          </>

          : null
        }

        {formCompArray.map(item => {

          return (
            <React.Fragment key={item.key}>
              {/* Search Address */}
              {(item.config.type === 'searchBar' && currentScreen === 'form' && coverageSearch === 'on')

                ? <div className="search-section-wrapper">

                  <Heading>
                    {item.config.name}
                  </Heading>

                  <div className="search-bar-wrapper">

                    <FibreDealsSearch
                      value={item.config.value}
                      inputIdentifier={item.key}
                      updateValue={formComponentChangeHandler}
                      onAddressSelection={(address) => getAddressDetails(address)}
                      automationidattr={item.key}
                      resetCoverageState={resetCoverageState} />
                  </div>
                </div>

                : null
              }
            </React.Fragment>
          );
        })
        }

        {coverageSearch === 'on'
          ? hasCoverage === coverageState.HAS_COVERAGE &&

          <>
            { currentScreen === 'form' &&

              <FibreStatusSection
                status="success"
                heading="Great news! Fibre is available in your area."
                desc="Please give us your information and a call centre agent will be in touch." />
            }

            { currentScreen === 'form'

              ? <LeadsForm
                onSubmit={submitClickHandler}
                apiError={isError} />

              : <DealsSuccess
                referenceNo={referenceNo} />
            }
          </>

          : null

        }

        { hasCoverage === coverageState.NO_COVERAGE &&

          <>
            <FibreStatusSection
              status="fail"
              heading="Fibre is not yet available in your area."
              desc="Don't worry, you can still enjoy speedy and reliable connectivity with our Home Internet offers." />

            <Banner />
          </>
        }
      </div>

      { coverageSearch === 'off' && currentScreen === 'form' && (
        <div style={{background: 'white'}}>
          <div className='divider-container'>
            <div className='divider-upper-sub-container' style={{background: '#141827'}}>
              <div className='divider-upper' style={{background: 'white', borderRadius: '0 0 80px 0'}}></div>
            </div>
          </div>
          <WhyChooseVodacomFibre />
        </div>
      )}
    </div>
  );
};

DealsForFTTHS.propTypes = {
  status: PropTypes.string,
  heading: PropTypes.string,
  desc: PropTypes.string
};

export default DealsForFTTHS;
